import { gql } from '@apollo/client';
const SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_NOT_READY = gql `
  mutation SetWarehouseReleaseComponentVariantToNotReady($warehouseReleaseComponentVariantId: ID!) {
    setWarehouseReleaseComponentVariantToNotReady(
      warehouseReleaseComponentVariantId: $warehouseReleaseComponentVariantId
    ) {
      warehouseReleaseComponentVariant {
        id
      }
    }
  }
`;
export default SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_NOT_READY;
